/**
 * @generated SignedSource<<c2f7b770386f106384d167c4de9eeeb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LogoutInput = {
  clientMutationId?: string | null;
};
export type logoutMutation$variables = {
  input: LogoutInput;
};
export type logoutMutationVariables = logoutMutation$variables;
export type logoutMutation$data = {
  readonly logout: {
    readonly clientMutationId: string | null;
  } | null;
};
export type logoutMutationResponse = logoutMutation$data;
export type logoutMutation = {
  variables: logoutMutationVariables;
  response: logoutMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogoutPayload",
    "kind": "LinkedField",
    "name": "logout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "logoutMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "logoutMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d717f9fd9f0038cafba13205fa7d0672",
    "id": null,
    "metadata": {},
    "name": "logoutMutation",
    "operationKind": "mutation",
    "text": "mutation logoutMutation(\n  $input: LogoutInput!\n) {\n  logout(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "49dd9b0bccab2295cb9728346777a4c4";

export default node;
